// extracted by mini-css-extract-plugin
module.exports = {"input-container":"addItem_input-container__1ymlG","fileInput":"addItem_fileInput__yXXcu","file-info":"addItem_file-info__k_wr_","browse-btn":"addItem_browse-btn__38L16"};